import { Gondor } from "../Gondor";

const ACTIONS = {
  SAT: "/sat/",
  SAT_ITEM: "/sat/{id}/",
  ADD_SYSTEMS: "/sat/add/system",
  REMOVE_SYSTEMS: "/sat/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.SAT, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.SAT_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.SAT, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.SAT_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.SAT_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
